import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "s-filter" }
const _hoisted_2 = { class: "s-filter--header row justify-between" }
const _hoisted_3 = { class: "col-auto row items-center" }
const _hoisted_4 = { class: "col-auto" }
const _hoisted_5 = {
  key: 0,
  class: "s-filter--body row q-col-gutter-sm"
}
const _hoisted_6 = { class: "col-12 s-filter--control" }
const _hoisted_7 = { class: "row q-gutter-y-md justify-start" }
const _hoisted_8 = { class: "col-12 col-md-auto" }
const _hoisted_9 = { class: "row q-gutter-x-lg q-gutter-y-sm justify-center" }
const _hoisted_10 = { class: "col-auto" }
const _hoisted_11 = { class: "col-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_s_btn = _resolveComponent("s-btn")!
  const _component_q_skeleton = _resolveComponent("q-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "s-pr-sm" }, "Фильтры", -1)),
        (_ctx.appliedFiltersCount)
          ? (_openBlock(), _createBlock(_component_q_badge, {
              key: 0,
              class: "s-badge s-badge--rounded s-badge--mini",
              outline: "",
              color: "brand"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.appliedFiltersCount), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_s_btn, {
              key: 0,
              type: "icon",
              class: _normalizeClass({ 'rotate-180': _ctx.show }),
              icon: "app:arrow-light-bottom",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show = !_ctx.show))
            }, null, 8, ["class"]))
          : (_openBlock(), _createBlock(_component_q_skeleton, {
              key: 1,
              class: "s-skeleton",
              width: "36px",
              type: "QBtn",
              animation: "fade"
            }))
      ])
    ]),
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "default", { filters: _ctx.filters }),
          _createElementVNode("div", _hoisted_6, [
            _renderSlot(_ctx.$slots, "controls", { reset: _ctx.reset }, () => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_s_btn, {
                        label: "Очистить фильтра",
                        "no-caps": "",
                        icon: "app:close",
                        type: "light",
                        onClick: _ctx.reset
                      }, null, 8, ["onClick"])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_s_btn, {
                        label: "Применить",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('apply-filter', _ctx.innerValue)))
                      })
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}